import React from 'react';

import TerraOverlay from '@components/TerraOverlay';

import { useFeatureFlags } from '@hooks/useFeatureFlags';

import BaseLayout from './BaseLayout';
import useMenuLinks from './useMenuLinks';
import { processViewSettings } from './util';

const UserLayout: React.FC<{
  friendlyName?: string | null;
  children: React.ReactNode;
  showHeader?: boolean;
  loading?: boolean;
  mobile?: boolean;
  limitHeight?: boolean;
  showSpeedDial?: boolean;
}> = ({
  friendlyName,
  children = null,
  showHeader = false,
  loading = false,
  showSpeedDial = true,
}) => {
  const { flags } = useFeatureFlags();
  const { patientLinks } = useMenuLinks();

  const USER_SETTINGS = processViewSettings([
    [
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['reminders', true],
      ['profile', true],
      ['contacts', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
      ['healthDevices', true],
      ['shareHistory', true],
      ['report', true],
      ['more', true],
      ['appInformation', true],
    ],
  ]);

  const USER_SETTINGS_MOBILE = processViewSettings([
    [
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['messenger', flags.isMessengerUseChatEnabled],
      ['routines', true],
      ['summary', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
      ['healthDevices', true],
      ['shareHistory', true],
    ],
  ]);

  return (
    <>
      <TerraOverlay />
      <BaseLayout
        friendlyName={friendlyName}
        links={patientLinks}
        loading={loading}
        showHeader={showHeader}
        showSpeedDial={showSpeedDial}
        settings={{
          desktop: USER_SETTINGS,
          mobile: USER_SETTINGS_MOBILE,
        }}
      >
        {children}
      </BaseLayout>
    </>
  );
};

export default UserLayout;
